export default "__VITE_ASSET__BxtY5bIH__"